
import React, { useState } from 'react';
import AIButton from './AIButton';
import AIModal from './AIModal';

const AIChat: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    setIsModalOpen(prevState => !prevState);
  };

  return (
    <>
      <AIButton onClick={toggleModal} />
      {isModalOpen && <AIModal onClose={toggleModal} />}
    </>
  );
};

export default AIChat;
